import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// TR
import navbarTR from './locales/tr/navbar.json';
import aboutpageTR from './locales/tr/aboutpage.json';
import careerpageTR from './locales/tr/careerpage.json';
import contactpageTR from './locales/tr/contactpage.json';
import cookiebannerTR from './locales/tr/cookiebanner.json';
import faqpageTR from './locales/tr/faqpage.json';
import projectpageTR from './locales/tr/projectpage.json';
import footerTR from './locales/tr/footer.json';
import legalpagesTR from './locales/tr/legal.json';
import technologiesTR from './locales/tr/technologies.json';
import floatingbuttonsTR from './locales/tr/floatingbuttons.json';
import homepageTR from './locales/tr/homepage.json';

// EN
import navbarEN from './locales/en/navbar.json';
import aboutpageEN from './locales/en/aboutpage.json';
import careerpageEN from './locales/en/careerpage.json';
import contactpageEN from './locales/en/contactpage.json';
import cookiebannerEN from './locales/en/cookiebanner.json';
import faqpageEN from './locales/en/faqpage.json';
import projectpageEN from './locales/en/projectpage.json';
import footerEN from './locales/en/footer.json';
import legalpagesEN from './locales/en/legal.json';
import technologiesEN from './locales/en/technologies.json';
import floatingbuttonsEN from './locales/en/floatingbuttons.json';
import homepageEN from './locales/en/homepage.json';

const resources = {
  tr: {
    translation: navbarTR, 
    aboutpage: aboutpageTR,
    careerpage: careerpageTR,
    contactpage: contactpageTR,
    cookiebanner: cookiebannerTR,
    faqpage: faqpageTR,
    projectpage: projectpageTR,
    footer: footerTR,
    legalpages: legalpagesTR,
    technologies: technologiesTR,
    floatingbuttons: floatingbuttonsTR,
    homepage: homepageTR
  },
  en: {
    translation: navbarEN, 
    aboutpage: aboutpageEN,
    careerpage: careerpageEN,
    contactpage: contactpageEN,
    cookiebanner: cookiebannerEN,
    faqpage: faqpageEN,
    projectpage: projectpageEN,
    footer: footerEN,
    legalpages: legalpagesEN,
    technologies: technologiesEN,
    floatingbuttons: floatingbuttonsEN,
    homepage: homepageEN 
  }
};

const defaultLanguage = 'tr';

const savedLanguage = localStorage.getItem('preferredLanguage') || defaultLanguage;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage, 
    fallbackLng: defaultLanguage,
    debug: process.env.NODE_ENV === 'development',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('preferredLanguage', lng);
});

export default i18n;